import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const OrgContext = createContext(null);

export function OrgProvider({ children }) {
  const { user } = useAuth();
  const [orgs, setOrgs] = useState([]);
  const [activeOrg, setActiveOrg] = useState(null);
  const [membership, setMembership] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadOrgs = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get("/orgs");
      setOrgs(data || []);
      const primary = (data || [])[0] || null;
      setActiveOrg(primary);
      if (primary) {
        setMembership({ role: primary.my_role });
      }
    } catch {
      // non-blocking
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    loadOrgs();
  }, [loadOrgs]);

  function switchOrg(orgId) {
    const found = orgs.find((o) => o.id === orgId);
    if (found) {
      setActiveOrg(found);
      setMembership({ role: found.my_role });
    }
  }

  return (
    <OrgContext.Provider value={{ orgs, activeOrg, membership, loading, loadOrgs, switchOrg }}>
      {children}
    </OrgContext.Provider>
  );
}

export function useOrg() {
  const ctx = useContext(OrgContext);
  if (!ctx) throw new Error("useOrg must be used inside OrgProvider");
  return ctx;
}
